// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"193":"619e7b9f","384":"95c36d4d"}[chunkId] + ".chunk.js");